// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"QuizTraining__mainContainer___2W2Ym","buttonContainer":"QuizTraining__buttonContainer___1XVk0","questionContainer":"QuizTraining__questionContainer___6ad9r"};